import styled from 'styled-components';
import BaseButton from '.';

export const ClydeButton = styled(BaseButton)`
  box-sizing: border-box;

  // Brand guidelines for buttons
  font-size: 16px;
  font-family: var(--font-family);
  font-weight: 400;
  text-align: center;
  line-height: ${24 / 16}em;
  border-radius: 8px;
  cursor: pointer;
`;
